import type { CameraFollowMode } from '../circuits/circuit3dPreview.js';

export const CAMERA_MODE_OPTIONS: { mode: CameraFollowMode; label: string }[] = [
  { mode: 'free', label: 'Libre' },
  { mode: 'me', label: 'Ma voiture' },
  { mode: 'active', label: 'Voiture active' },
];

export function cameraModeLabel(mode: CameraFollowMode): string {
  return CAMERA_MODE_OPTIONS.find((o) => o.mode === mode)?.label ?? 'Libre';
}
